import { useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { TableProps, TableRow } from "@kanda-libs/ks-component-ts";
import usePagination from "hooks/usePagination";
import usePaymentTableSorting from "components/payment/PaymentTable/usePaymentTableSorting";
import { sortData } from "components/payment/PaymentTable/helpers";
import { selectors } from "store";
import paymentSelectors from "store/selectors/payments";
import useSearchQuery from "hooks/useSearchQuery";
import { SEARCH_OPTIONS } from "./constants";

export default function usePaymentTableProps(): TableProps {
  const { push } = useHistory();
  const isLoading = useSelector(selectors.getIsLoading);

  const formattedPayments = useSelector(paymentSelectors.getFormattedPayments);

  const { hits } = useSearchQuery(
    formattedPayments,
    "payments",
    SEARCH_OPTIONS
  );

  const { sorting, order, onAction } = usePaymentTableSorting();

  const onRowClicked = useCallback(
    (row?: TableRow) => {
      if (row?.original?.link) {
        push(row.original.link);
      }
    },
    [push]
  );

  const { pageIndex, perPage, totalPages, setPageIndex } = usePagination(
    hits.length
  );

  const data = useMemo(() => {
    const rawData = hits.map((hit) => hit.item);
    return sortData(rawData, sorting, order).slice(
      pageIndex * perPage,
      pageIndex * perPage + perPage
    );
  }, [order, pageIndex, perPage, sorting, hits]);

  return {
    data,
    onAction,
    pageIndex,
    totalPages,
    perPage,
    setPage: setPageIndex,
    isLoading,
    onRowClicked,
  } as unknown as TableProps;
}
